export enum BusinessObjectType {
    UNKNOWN= 0,
    VEHICLE= 1,
    DEVICE= 2,
    DRIVER= 3,
    USER= 6,
    DISPATCH_TECHNICIAN= 7,
    CLIENT= 8,
    SHIPMENT= 9,
    DELIVERY_CARRIER= 10,
    DELIVERY_CLIENT= 11,
    MEASURE_ZONE= 12,
    DELIVERY_ADDRESS= 14,
    CONTACT= 15,
    REPORT= 16,
    REPORT_DYNAMIC= 17,
    HIERARCHY= 18,
    FILE_LIST_FILE= 19,
    DISPATCH_TASK= 20,
    DELIVERY_ADDRESS_LOCATION= 21,
    DEPARTMENT= 22,
    DISPATCH_TEAM= 23,
    DELIVERY_ORDER= 24,
    DISPATCH_REGION= 25,
    DISPATCH_BASE= 26,
    APPOINTMENT= 27,
    DELIVERY_PARTNER= 28,
    COMPLAINT= 29,
    COMPLAINT_INTENT= 30,
    SUPPLIER= 31,
    DELIVERY_TASK= 32,
    DELIVERY_PACK= 33,
    CALENDAR_EVENT= 34,
    DELIVERY_PLAN= 35,
    DOCUMENT= 36,
    OBJECT_NOTIFY= 37,
    TRANSLATION= 38,
    BOARD_NOTICE= 39,
    DICTIONARY_ITEM= 40,
    ADDITIONAL_SERVICE= 41,
    DELIVERY_ROUTE= 42,
    AUCTION= 43,
    WORKLOAD= 44,
    YMS_SHIPMENT= 45,
    WEBBOOKING_ORDER= 46,
    ROLE= 47,
  }
  